import { createPasswordSchema, emailSchema, phoneRequiredSchema, select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema, urlOptionalSchema, urlRequiredSchema } from "utils/validation/validationHelpers";
import { object, array, string } from 'yup';

const addCoordinatorSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    city: stringRequiredSchema,
    status: statusSchema,
    grade: select2RequiredSchema,
    isLoginAllowed: stringRequiredSchema,
    password: createPasswordSchema,
    // school_id: select2RequiredSchema,
    school_ids: array()
        .of(
            object().shape({
                label: string().required("School label is required"),
                value: string().required("School value is required"),
            })
        )
        .min(1, "At least 1 school is required")
        .required("School is required"),
    // school_division: select2RequiredSchema
});

const editCoordinatorSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    city: stringRequiredSchema,
    status: statusSchema,
    grade: select2RequiredSchema,
    isLoginAllowed: stringRequiredSchema,
    // school_id: select2RequiredSchema,
    school_ids: array()
        .of(
            object().shape({
                label: string().required("School label is required"),
                value: string().required("School value is required"),
            })
        )
        .min(1, "At least 1 school is required")
        .required("School is required"),
    // school_division: select2RequiredSchema
});

export { addCoordinatorSchema, editCoordinatorSchema };